<script lang="ts">
    import { getContext, onMount } from "svelte";
    import { userState } from "../../modules/store";
    import type { UserProcessNavigator } from "../../modules/UserProcessNavigator";
    import type { ApiService } from "../../services";
    import {ResultStatus} from "../../services";
    const api: ApiService = getContext("api-service");
    const nav: UserProcessNavigator = getContext("navigator");
    let assessmentUrl: string = null;
    nav.navigateToDefaultForCurrentState();

    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window.innerWidth <= 700;
        window.addEventListener('resize', () => {
            isMobile = window.innerWidth <= 700;
        });
    }

    onMount(() => {
        // Scroll to top when component mounts
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        
        let try_count:number=0;
        let intervalHandle = setInterval(async () => {
            try_count++;
            let resultsStatus = await api.CheckResultsStatusAsync(
                $userState.assessment.id
            );
            if (resultsStatus.success && resultsStatus.data.status == ResultStatus.Found) {
                assessmentUrl = resultsStatus.data.url;
            }
            if (
                try_count>100 ||
                resultsStatus.success == false ||
                resultsStatus.data.status != ResultStatus.Pending
            ) {
                clearInterval(intervalHandle);
            }
        }, 3000);

        return () => {
            clearInterval(intervalHandle);
        };
    });
</script>

{#if assessmentUrl}
  <div class="results-container">
    {#if isMobile}
      <div class="mobile-pdf-message">
        <span>Your results are ready.</span><br>
        <a href={assessmentUrl} target="_blank" rel="noopener" class="pdf-link">Tap here to view your PDF results in a new tab</a>
      </div>
    {:else}
      <iframe id="results" title="Your Results" src={assessmentUrl} />
    {/if}
  </div>
{:else}
  <div class="results-container">
    <div class="loading-message">Calculating your results...</div>
    <div class="loader"></div>
  </div>
{/if}

<style>
body, :global(body) {
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
}

.results-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  padding: 24px 0;
}

iframe {
  width: 100%;
  max-width: 900px;
  height: 80vh;
  border: 1.5px solid #e9ecef;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(44,62,80,0.10);
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  margin: 0 auto;
  display: block;
}

@media (max-width: 700px) {
  iframe {
    height: 70vh;
    min-height: 350px;
    max-width: 100vw;
    border-radius: 8px;
  }
}

.loader {
  border: 5px solid #444;
  border-radius: 50%;
  border-top: 5px solid rgb(247, 190, 22);
  width: 40px;
  height: 40px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  margin: 24px auto 0 auto;
  display: block;
}

.loading-message {
  color: #ffd966;
  font-size: 1.3rem;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
}

.mobile-pdf-message {
  color: #ffd966;
  font-size: 1.1rem;
  text-align: center;
  margin: 40px 0 10px 0;
}
.pdf-link {
  display: inline-block;
  margin-top: 18px;
  background: #ffd966;
  color: #2c3e50;
  padding: 14px 32px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 217, 102, 0.3);
}
.pdf-link:hover {
  background: #ffe066;
  color: #2c3e50;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
